import { useSessionOrNull } from '~/contexts/SessionContext';
import { StructureSetId } from '~/domain/changes/ids';
import { createStructureSetDetailView } from '~/domain/projections/factories';
import { StructureSetDetailView } from '~/domain/projections/views';
import { useDomainProjection } from './useDomainProjection';

/**
 * Subscribe to the detail view of a single structure set by its domain
 * id. Returns undefined when the id is undefined, there is no active
 * session, or no matching SS exists on the patient.
 *
 * Tolerates a missing session: consumers such as StructureSetItem can
 * mount before PatientSessionProvider's effect creates the session.
 */
export function useStructureSetDetailView(
    id: StructureSetId | undefined
): StructureSetDetailView | undefined {
    return useDomainProjection(
        useSessionOrNull(),
        'useStructureSetDetailView',
        [id],
        (patient) => {
            const ss =
                id === undefined ? undefined : patient.getStructureSetById(id);
            return ss ? createStructureSetDetailView(ss) : undefined;
        },
        undefined
    );
}
